import React from "react";
import { ArrowUpRight } from "lucide-react";
import { ETSY_FEATURED } from "@/config/social";

const ACCENT = { dtf: "var(--dtf-blue)", sc: "var(--sc-pink)" };
const ETSY_ORANGE = "#F1641E";

export default function EtsyRow() {
  return (
    <section
      className="border-y-2 border-black bg-[color:var(--muted)]"
      data-testid="etsy-row-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div className="flex items-center gap-4">
            <div
              className="w-12 h-12 border-2 border-black inline-flex items-center justify-center"
              style={{ background: ETSY_ORANGE, color: "#fff" }}
              aria-hidden
            >
              <i className="fa-brands fa-etsy text-lg" />
            </div>
            <div>
              <p className="label-mono text-[color:var(--muted-text)]">
                ALSO ON ETSY
              </p>
              <h2 className="font-display text-4xl md:text-5xl leading-[0.9] mt-1">
                JUST SOME FROM OUR ETSY.
              </h2>
            </div>
          </div>
          <a
            href="https://www.etsy.com/shop/DownToFilmApparel?etsrc=sdt"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-brutal"
            style={{ background: ETSY_ORANGE, color: "#fff", borderColor: "#000" }}
            data-testid="etsy-visit-shop"
          >
            Visit Etsy Shop <ArrowUpRight size={16} />
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {ETSY_FEATURED.map((item, i) => (
            <a
              key={i}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group border-2 border-black bg-white overflow-hidden"
              style={{ boxShadow: "4px 4px 0 0 #000" }}
              data-testid={`etsy-card-${i}`}
            >
              <div className="aspect-square overflow-hidden bg-[color:var(--muted)]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-3 border-t-2 border-black flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <p
                    className="label-mono text-[9px]"
                    style={{ color: ACCENT[item.brand] || "var(--muted-text)" }}
                  >
                    {item.brand === "sc" ? "The Sticky Chick" : "DTF Apparel"}
                  </p>
                  <p className="font-mono text-sm font-bold truncate">{item.title}</p>
                  <p className="label-mono text-[color:var(--muted-text)] mt-1">
                    {item.price}
                  </p>
                </div>
                <ArrowUpRight
                  size={16}
                  className="shrink-0 mt-1 opacity-40 group-hover:opacity-100 transition-opacity"
                  style={{ color: ETSY_ORANGE }}
                />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
